<mat-label class="subHeading">Activation Bonus (₹)<span *ngIf="isRequired" class="star">*</span></mat-label>
<input [maxlength]="7" formControlName="activation_bonus" type="text" placeholder="xxxxxxxxxx" class="rule mt-2" appNumberOnly/>

